var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStageFullBadgeNull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 199 199",
    style: {
      enableBackground: "new 0 0 199 199"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1413_1821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.5 198.5C154.176 198.5 198.5 154.176 198.5 99.5C198.5 44.8238 154.176 0.5 99.5 0.5C44.8238 0.5 0.5 44.8238 0.5 99.5C0.5 154.176 44.8238 198.5 99.5 198.5Z",
    fill: "#F0EFF0",
    fillOpacity: 0.79
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M102.5 148.7L157 94.2002C165.4 85.8002 165.4 72.0002 157 63.5002C148.6 55.1002 134.8 55.1002 126.3 63.5002L71.8 118C63.4 126.4 63.4 140.2 71.8 148.7C80.2 157.2 94 157.2 102.5 148.7Z",
    fill: "url(#paint0_linear_1413_1821)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M71.4 148.7L51.3 128.6C42.9 120.2 42.9 106.4 51.3 97.9001C59.7 89.5001 73.5 89.5001 82 97.9001L102 118C110.4 126.4 110.4 140.2 102 148.7C93.6 157.2 79.8 157.2 71.4 148.7Z",
    fill: "url(#paint1_linear_1413_1821)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1413_1821",
    x1: 156.958,
    y1: 63.5065,
    x2: 71.7826,
    y2: 148.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2678,
    stopColor: "#E6E2E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8ECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1413_1821",
    x1: 51.2193,
    y1: 97.876,
    x2: 102.051,
    y2: 148.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2678,
    stopColor: "#E6E2E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8ECF0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1413_1821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 199,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStageFullBadgeNull);
export default __webpack_public_path__ + "static/media/stage-full_Badge_null.886f6a19687d37bc6087c1b41a3bcd5b.svg";
export { ForwardRef as ReactComponent };